import styled, { css } from 'styled-components'
import { Block } from '../block/block'
import { Text } from '../typography/text'

export const Form = props => <Block as='form' spreadX {...props} />

export const FormGroup = props => <Block gap={8} {...props} />

export const FormLabel = props => (
  <FormLabelRoot
    tag='label'
    color='#232323'
    fontWeight={400}
    fontSize={15}
    lineHeight='120%'
    {...props}
  />
)

export const FormFeedbackMessage = props => (
  <FormFeedbackMessageRoot
    tag='span'
    color='#232323'
    fontWeight={400}
    fontSize={15}
    lineHeight='140%'
    {...props}
  />
)

export const FormHelpMessage = props => (
  <Text
    tag='span'
    fontSize={14}
    fontWeight={400}
    lineHeight='120%'
    color='#646f7b'
    {...props}
  />
)

const FormLabelRoot = styled(Text)`
  ${({ required = true }) =>
    required &&
    css`
      &::after {
        content: '*';
        color: #f44336;
        margin-left: 4px;
      }
    `}
`

const FormFeedbackMessageRoot = styled(Text)`
  ${({ isError = false }) =>
    isError &&
    css`
      color: #f44336;
    `}
`
